var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTtd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.49714 1.59937C5.42286 2.15385 4.41444 2.88065 3.51387 3.78121C2.61327 4.68182 1.88647 5.69024 1.33203 6.76452L9.04798 15.2184L17.5018 22.9343C18.5762 22.3798 19.5846 21.6531 20.4852 20.7525C21.3858 19.8519 22.1125 18.8435 22.667 17.7692L14.951 9.31532L6.49714 1.59937Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4868 20.7542C20.9902 20.2508 21.4392 19.7137 21.8344 19.1503L5.1195 2.4353C4.55611 2.83051 4.01897 3.27947 3.51558 3.78287C3.01219 4.28626 2.56322 4.8234 2.16797 5.38683L18.8829 22.1017C19.4462 21.7065 19.9834 21.2576 20.4868 20.7542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51431 20.7556C7.30026 24.5415 12.9861 25.2683 17.5023 22.9374L1.33251 6.76756C-0.998347 11.2838 -0.271457 16.9696 3.51431 20.7556Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4841 3.78193C16.6981 -0.00397435 11.0123 -0.730724 6.49609 1.60004L22.6659 17.7699C24.9968 13.2537 24.27 7.56784 20.4841 3.78193Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTtd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TTD.59b26d112107d3444acdfd51b83b592c.svg";